// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"1b795b35","366":"cccc1531","649":"7fd25fe7","737":"dbcfddd5"}[chunkId] + ".chunk.css";
};